import { render, staticRenderFns } from "./EvidenceSubmissionUserStatusV2.vue?vue&type=template&id=143510fe&scoped=true&"
import script from "./EvidenceSubmissionUserStatusV2.vue?vue&type=script&lang=js&"
export * from "./EvidenceSubmissionUserStatusV2.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceSubmissionUserStatusV2.vue?vue&type=style&index=0&id=143510fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143510fe",
  null
  
)

export default component.exports